import { Button, Cell, Grid, HFlow, VFlow } from 'bold-ui'
import { TextAreaField } from 'components/form'
import {
  AntecedenteCiapSelectField,
  AntecedenteCiapSelectFieldModel,
} from 'components/form/field/select/CiapSelectField/AntecedenteCiapSelectField'
import { CiapCapituloEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import {
  EditableListForm,
  EditableListFormProps,
  EditableListFormRenderProps,
} from 'view/atendimentos/detail/components/EditableListForm'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { AntecedentesFamiliaresCiapFormModel, defaultItensAntecedenteCiap } from '../model-antecedentes'
import { familiarValidator } from '../validator'
import { AntecedentesFamiliaresCidSelectField } from './AntecedentesFamiliaresCidSelectField'

interface AntecedentesFamiliaresCiapFormProps
  extends Pick<EditableListFormProps<AntecedentesFamiliaresCiapFormModel>, 'initialValues' | 'onSubmit'> {
  isEditing?: boolean
  formValues?: Array<AntecedentesFamiliaresCiapFormModel>
  onCancel?(): void

  cidadao: CidadaoAtendimento
  canAddCid10: boolean
}

export function AntecedentesFamiliaresCiapForm(props: AntecedentesFamiliaresCiapFormProps) {
  const { initialValues, isEditing, cidadao, formValues, canAddCid10, onCancel, ...rest } = props

  const prefix = isEditing ? initialValues?._id ?? 'edit' : 'new'

  const defaultItens = useMemo(() => defaultItensAntecedenteCiap(cidadao), [cidadao])

  const ciapIsEqual = (item: AntecedenteCiapSelectFieldModel) => {
    return !!(formValues ?? []).find((o2) => item.id === o2.ciap?.id && o2._id !== initialValues?._id)
  }

  const renderForm = ({
    handleSubmit,
    name,
    values,
  }: EditableListFormRenderProps<AntecedentesFamiliaresCiapFormModel>) => {
    return (
      <VFlow vSpacing={4}>
        <Grid>
          <Cell size={6}>
            <AntecedenteCiapSelectField
              name={name.ciap}
              label='CIAP 2'
              capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
              excluirCIAPsDAB
              menuMinWidth={620}
              formValues={formValues}
              defaultItens={defaultItens}
              itemIsDisabled={ciapIsEqual}
            />
          </Cell>

          {canAddCid10 && (
            <Cell size={6}>
              <AntecedentesFamiliaresCidSelectField
                name={name.cid10}
                label='CID 10'
                ciapRelacionada={values?.ciap?.id}
                currentItemId={values?._id}
                formValues={formValues}
                menuMinWidth={620}
              />
            </Cell>
          )}

          <Cell size={12}>
            <TextAreaField
              name={name.observacao}
              label='Observações'
              maxLength={200}
              placeholder='Insira as demais informações relacionadas aos antecedentes familiares'
              resize='none'
            />
          </Cell>
          <Cell size={12}>
            <HFlow justifyContent='flex-end'>
              {isEditing && onCancel && (
                <Button kind='normal' onClick={onCancel} size='small'>
                  Cancelar
                </Button>
              )}
              <Button kind='primary' onClick={handleSubmit} size='small'>
                {isEditing ? 'Salvar' : 'Adicionar'}
              </Button>
            </HFlow>
          </Cell>
        </Grid>
      </VFlow>
    )
  }

  return (
    <EditableListForm<AntecedentesFamiliaresCiapFormModel>
      render={renderForm}
      initialValues={initialValues}
      validate={familiarValidator(canAddCid10)}
      prefix={prefix}
      {...rest}
    />
  )
}
